/**
 * *************************************************************************************
 * * ⚠️ The environments code is being migrated to @library/environment.               *
 * * As a short-term measure the 'monolith' code will re-export library code           *
 * *************************************************************************************
 */

export { getClientProtocol } from '@library/environment/src/browserEnvironment'

export { canUseWindow } from '@library/environment'
export { getWindow } from '@library/environment/browser'
